module.exports = __webpack_public_path__ + "files/6b4af324e4a0d0f7ac19a69a2f456ebe.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/lato-bold-webfont.woff
 ** module id = 920
 ** module chunks = 0
 **/